module.exports = __webpack_public_path__ + "img/xtzdhjs.49c1fe0b.jpg";